import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

const useStyles = makeStyles()(() => ({
  buttons: {
    ...dFlex(),
    gap: 8,
  },
  button: {
    padding: 6,
    width: 44,
  },
}));

export default useStyles;
